module.exports = __webpack_public_path__ + "img/select-icon.fb5ff157.svg";